/**
 * Shown by TanStack Router while a route's lazy chunk and loader resolve.
 * Skeleton mirrors the standard page shell (breadcrumb + title + content
 * block) so layout doesn't jump when the real page swaps in.
 */
export function RoutePending() {
  return (
    <main
      id="main-content"
      aria-busy="true"
      aria-live="polite"
      style={{
        maxWidth: 1100,
        margin: '0 auto',
        padding: 'var(--sp-lg) var(--sp-md) var(--sp-xl)',
      }}
    >
      <span style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Loading page…</span>
      <div style={{ display: 'grid', gap: '0.9rem', maxWidth: 760 }}>
        <Bar w="40%" h={14} />
        <Bar w="70%" h={34} />
        <Bar w="90%" h={14} />
        <Bar w="85%" h={14} />
        <Bar w="60%" h={14} />
        <div style={{ height: 'var(--sp-md)' }} />
        <Bar w="100%" h={180} radius={8} />
        <Bar w="100%" h={120} radius={8} />
      </div>
      <style>{`
        @keyframes route-pending-shimmer {
          0% { background-position: -400px 0; }
          100% { background-position: 400px 0; }
        }
      `}</style>
    </main>
  );
}

function Bar({ w, h, radius = 4 }: { w: string; h: number; radius?: number }) {
  return (
    <div
      aria-hidden="true"
      style={{
        width: w,
        height: h,
        borderRadius: radius,
        background:
          'linear-gradient(90deg, rgba(30,77,60,0.07) 0%, rgba(30,77,60,0.14) 50%, rgba(30,77,60,0.07) 100%)',
        backgroundSize: '800px 100%',
        animation: 'route-pending-shimmer 1.4s ease-in-out infinite',
      }}
    />
  );
}
